import React from "react";

interface OwnProps {
    icon: string;
}

interface OwnState {
}

export class Icon extends React.Component<OwnProps, OwnState> {
    public render() {
        return <i className={"fa fa-" + this.props.icon}></i>;
    }
}

export const LoadingIcon: React.SFC<{}> = (props) => {
    return <Icon icon="spinner fa-spin" />;
};



// WEBPACK FOOTER //
// ./src/components/generic/Icon.tsx